<template>
  <div>
    <v-container class="pt-0 pb-5" v-if="payment_request.uuid_commande && payment_request.status == 'pending'">
      <v-row>
        <v-col>
          <div class="pa-2 rounded elevation-1 bg-white">
            <h4 class="font-weight-bold my-3"><v-icon icon="mdi-file-document-edit-outline" color="primary"
                size="xs-small"></v-icon> Récapitulatif de ma commande</h4>
            <v-row>
              <v-col cols="12" md="6" offset-md="3">
                <div class="d-flex flex-column align-start justify-stretch rounded bg-dark pa-4 mt-2">
                  <div class="d-flex justify-space-between w-100">
                    <div>Nombre d'articles</div>
                    <div>1</div>
                  </div>
                  <div class="d-flex justify-space-between w-100">
                    <div>Sous Total</div>
                    <div>{{ parseFloat(payment_request.total) - 2 }}€</div>
                  </div>
                  <div class="d-flex justify-space-between w-100">
                    <div>Frais de gestion</div>
                    <div>2€</div>
                  </div>
                  <div class="d-flex justify-space-between w-100">
                    <div>Total à payer</div>
                    <div>{{ payment_request.total }}€</div>
                  </div>
                </div>
              </v-col>

              <v-col cols="12" md="6" offset-md="3">
                <AfterAccessCheckout :request="payment_request"></AfterAccessCheckout>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="pt-0 pb-5" v-else>
      <v-row>
        <v-col>
          <div class="pa-2 rounded elevation-1 bg-white">
            <v-alert>Accès refusé. Ce lien n'est pas valide, ou le paiement a déjà été effectué.</v-alert>
            <div class="mt-3 d-flex justify-center">
              <router-link :to="{ name: 'Home' }"><v-btn color="primary-dark">Retour à l'accueil</v-btn></router-link>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";

import AfterAccessCheckout from "@/components/Checkout/Access_Request_Payment_Checkout.vue";
export default {
  components: {
    AfterAccessCheckout,
  },
  data() {
    return {
      crypted_id: "",
      payment_request: {},
    };
  },
  methods: {

    async get_payment_request() {
      let res = await axios.get("/payment_request/get.php?token=" + this.crypted_id);
      if (res.data.error) {
        console.log(res.data.error);
        return await false;
      } else {
        this.payment_request = res.data;
        return await true;
      }
    },
  },
  async created() {
    this.crypted_id = this.$route.query.req;
    await this.get_payment_request();
  },
};
</script>

<style lang="scss" scoped></style>